import request from './cache/requestCache';
import proxy from './requestProxy';

export function newRelicTrackEvent(payload) {
    const { newrelicInsertKey, newrelicAccountId, trackingData } = payload;
    const url = `https://insights-collector.newrelic.com/v1/accounts/${newrelicAccountId}/events`;

    return request.post(url)
        .send(trackingData)
        .set('X-Insert-Key', newrelicInsertKey)
        .set('Accept', 'application/json')
        .use(proxy)
        .then(res => {
            return JSON.stringify(res.body);
        })
        .catch((err) => {
            return {
                "success": false,
                "err": err
            }
        });
}


// WEBPACK FOOTER //
// ./app/lib/api/newRelicApi.js